import { errorHandler } from '@/composables/errorHandler'
import { t } from '@/i18n'
import { notificationService } from '@/services/notificationService'
import { useCommonStore, useOperatorReportingStore, useReportExecutionStore } from '@/stores'
import { reportExecutionService } from '@/views/Reports/services/reportExecutionService'

export function createOperatorReportingCreatePrefetchGuard() {
    return async (to: { name?: string | symbol | null }) => {
        const commonStore = useCommonStore()
        const operatorReportingStore = useOperatorReportingStore()
        const reportExecutionStore = useReportExecutionStore()
        const createReportContext = reportExecutionStore.operatorReportingCreateContext
        const workspace = operatorReportingStore.selectedWorkspace

        reportExecutionStore.setPrefetchedCreateTask(null)

        if (!createReportContext?.taskId || !createReportContext.processId || !workspace) {
            notificationService.error(t('reports.reportExecution.create.notifications.missingContext'))
            return { name: 'reportsOperatorReportingHome' }
        }

        commonStore.toggleMainLoader(true)

        try {
            const response = await reportExecutionService.fetchTaskDetails(createReportContext)
            const task = response.data
            const plate =
                to.name === 'reportsOperatorReportingCreatePrint'
                    ? reportExecutionService.findPrintEntryPlate(task, createReportContext.plateNumber)
                    : reportExecutionService.findPlate(task, createReportContext.plateNumber)

            if (!plate) {
                notificationService.info(t('reports.reportExecution.create.notifications.taskFullyReported'))
                return { name: 'reportsOperatorReportingHome' }
            }

            reportExecutionStore.setPrefetchedCreateTask(task)

            return true
        } catch (error) {
            errorHandler(error)
            commonStore.toggleMainLoader(false)
            return false
        }
    }
}
